export function getCspNonce(): string | undefined {
  const nonce =
    document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.getAttribute("content") ??
    document.querySelector<HTMLScriptElement>("script[nonce]")?.nonce;

  return nonce ? nonce : undefined;
}
